import PropTypes from "prop-types"
import React, { useState, useEffect, useMemo } from "react"
import { 
  Container, 
  Table, 
  Modal,
  ModalBody,
  ModalHeader} from "reactstrap"

import "react-multi-carousel/lib/styles.css"

import { Link, redirect, useNavigate } from "react-router-dom"

import jwtDecode from "jwt-decode"
//i18n
import { withTranslation } from "react-i18next"
//pass request back end
import axios from "axios";
import moment from "moment";
import Loader from "react-spinner-loader";
import { SECURITY_KEY, BASE_URL } from "../../../global";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const ManualMarkList = props => {


    //Dedoce user details start
    function decodeAccessToken(token) {
      try {
        const decoded = jwtDecode(token)
        return { success: true, data: decoded }
      } catch (error) {
        return { success: false, error: error.message }
      }
    }
  
    const [username, setusername] = useState(null)
  
    useEffect(() => {
      if (localStorage.getItem("authStudentUser")) {
        const obj = JSON.parse(localStorage.getItem("authStudentUser"))
        const jwtdecode = decodeAccessToken(obj)
  
       // console.log(jwtdecode.data)
  
        setusername(jwtdecode.data)
        //}
      }
    }, [props.success])

  const [loader, setLoader] = useState(false);
  
  const authUser = JSON.parse(localStorage.getItem('authStudentUser')) || null;

  const navigate = useNavigate();

   //fetch data start
  const [sessionData, setSessionData] = useState([]);
  const [searchText, setSearchText] = useState(null)
    useEffect(() => {
    if (username) {
      fetchManualMarkData()
    }
  }, [username])
  const fetchManualMarkData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      setLoader(true)
    
      axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
      axios
      .post(BASE_URL + "studentSession/getActivityManualMarkDetails", {
        cent_timezone_identifier: localStorage.getItem("cent_timezone_identifier") || "",
      })
      .then(responseSession => {
        if (responseSession.data.length > 0) {
          setSessionData(responseSession.data)
        } else {
          setSessionData([])
        }

        setLoader(false)
      })
      .catch(error => {
        setLoader(false)
        // console.log(error?.response?.data?.error)
        if (
          (error?.response?.status === 403 || error?.response?.status === 401) &&
          (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
        ) {
          localStorage.clear()
          navigate("/login")
        }
      })
    } else {
      navigate("/login")
    }
  }

  const CountTotalCoinsActvity = (activity) => {
    let total_coins_stu = 0;
    let Completed_total_stu = 0;
  
    if (!activity || !activity.LessonActivitiesQuestions?.length) return "0/0";
  
    Completed_total_stu = Number(activity?.coins_earned) || 0;
  
    const { LessonActivitiesQuestions, activity_type, activity_node } = activity;
  
    if ([0, 8].includes(Number(activity_type))) {
      LessonActivitiesQuestions.forEach((lsquestion) => {
        if (Number(lsquestion.fk_sub_id) === 2) {
            lsquestion.question?.forEach(lsquestionParts => {
              total_coins_stu += lsquestionParts.question_parts.length * 2
            }) || 0
          
        } else if (Number(lsquestion.fk_sub_id) === 1) {
          lsquestion.english_question?.forEach((part) => {
            if ([10, 13].includes(Number(part.english_question_category_id))) {
              total_coins_stu += (part.english_question_parts?.filter(
                (p) => p.english_question_answers?.[0]?.english_answer_text
              ).length || 0) * 2;
            } else {
              total_coins_stu += (part.english_question_parts?.length || 0) * 2;
            }
          });
        }
      });
    } else if (Number(activity_type) === 2) {
      LessonActivitiesQuestions.forEach((lsquestion) => {
        total_coins_stu += (lsquestion.question?.length || lsquestion.english_question?.length || 0) * 2;
      });
    } else if ([1, 3, 4, 5].includes(Number(activity_type))) {
      total_coins_stu += Number(activity_node?.[0]?.coins) || 2;
    } else if (Number(activity_type) === 7) {
      total_coins_stu += 20;
    } else {
      LessonActivitiesQuestions.forEach((lsquestion) => {
        total_coins_stu += (lsquestion.question?.length || 0) * 2;
      });
    }
  
    return `${Completed_total_stu}/${total_coins_stu}`;
  };

  const prepareSessionActivityList = (sessionData = []) => {
    return sessionData.flatMap(session =>
      (session?.Lesson?.LessonActivities || []).map(activity => ({
        sest_name: session.sest_name,
        ses_date: session.ses_date,
        ses_start_time: session.ses_start_time,
        ses_end_time: session.ses_end_time,
        pk_lesson_activity_key: activity.pk_lesson_activity_key,
        fk_sub_id: activity.fk_sub_id,
        coins: activity? CountTotalCoinsActvity(activity) : 0,
        type: activity?.activity_type === 0 
                      ? "Online Activities" || ""
                      : activity?.activity_type === 1
                      ? "Video" || ""
                      : activity?.activity_type === 2 
                      ? "Diagnostics"|| ""
                      : activity?.activity_type === 3
                      ? "Link" || ""
                      : activity?.activity_type === 4
                      ? "Task" || ""
                      : activity?.activity_type === 5
                      ? "WorkSheet" || ""
                      : activity?.activity_type === 6 
                      ? "Video" || ""
                      : activity?.activity_type === 7
                      ? "WorkSheet" || ""
                      : activity?.activity_type === 8
                      ? "Summative" || ""
                      : activity?.activity_type === 10
                      ? "File" || ""
                      :"",
        name: activity?.activity_type === 0 
                ? activity?.activity_node?.[0]?.node_name || ""
                : activity?.activity_type === 1
                ? activity?.activity_node?.[0]?.name || ""
                : activity?.activity_type === 2 
                ?  ""
                : activity?.activity_type === 3
                ? activity?.activity_node?.[0]?.name || ""
                : activity?.activity_type === 4
                ? activity?.activity_node?.[0]?.name || ""
                : activity?.activity_type === 5
                ? activity?.activity_node?.[0]?.name || ""
                : activity?.activity_type === 6 
                ? activity?.activity_node?.[0]?.video_name || ""
                : activity?.activity_type === 7
                ? activity?.activity_node?.[0]?.node_name || ""
                : activity?.activity_type === 8
                ? activity?.activity_node?.[0]?.name || ""
                : activity?.activity_type === 10
                ? activity?.activity_node?.[0]?.name || ""
                : "Activity",
        status: activity?.status === 1 ? "Completed" : (activity?.status === 0 ? "Incomplete" : "N/A"),
        activityMethod: Number(activity?.marked_for_homework) === 1 ? "Homework" : "Lesson",
        activityType: activity?.activity_type,
        marked_for_homework: activity?.marked_for_homework,
        score: [0, 2, 6, 7, 8].includes(activity?.activity_type)
                ? activity?.mastryScore || 0
                : [1, 3, 4, 10].includes(activity?.activity_type)
                  ? activity?.mastryScore || (activity?.status === 1 ? 100 : 0)
                  : [5].includes(activity?.activity_type)
                    ? activity?.mastryScore ||
                      (activity?.status === 1 &&
                      activity?.LessonActivitiesQuestions?.[0]?.marked_for_manual_marking > 0
                        ? 100
                        : 0)
                    : 0,
      }))
    );
  }

  const arrayFormateActvity = prepareSessionActivityList(sessionData || []) || [];

  const globalSearchFilter = (data = [], searchText = "") => {
  if (!searchText?.trim()) return data;

  const search = searchText.toLowerCase();

  return data.filter(item =>
    [
      item.name,
      item.activityMethod,
      item.coins,
      item.sest_name,
      moment(item.ses_date).format("DD MMM YYYY")
    ].some(value =>
      String(value || "").toLowerCase().includes(search)
    )
  );
};

const filteredActivities = useMemo(() => {
  return globalSearchFilter(
    prepareSessionActivityList(sessionData || []),
    searchText
  );
}, [sessionData, searchText]);


  const filterState = {
    redirectPage: 'EVALUATIONS',
    url: "/manualMark"
  };
    const assessementActivitySummary = activity => {
      console.log(activity)
      if (
        activity.pk_lesson_activity_key &&
        activity.pk_lesson_activity_key != ""
      ) {
        if (activity.fk_sub_id && activity.fk_sub_id != "") {
         
          
          navigate(
            "/summary/" +
              activity.pk_lesson_activity_key +
              "?type=" +
              activity.fk_sub_id +
              "&homework="+activity.marked_for_homework, 
              {
                state: {
                  ...filterState
                },
              }
          )
        } else {
          toast.error("Sorry, Activity Key Missing", {
            autoClose: 3000, // 3 seconds in this example
          })
        }
      } else {
        toast.error("Sorry, Activity Key Missing", {
          autoClose: 3000, // 3 seconds in this example
        })
      }
    }

    const WorksheetActivity = activity => {
       console.log(activity)
        if (
          activity.pk_lesson_activity_key &&
          activity.pk_lesson_activity_key != ""
        ) {
          if (activity.fk_sub_id && activity.fk_sub_id != "") {
            navigate(
              "/worksheet/" +
                activity.pk_lesson_activity_key +
                "?type=" +
                activity.fk_sub_id +
                "&homework="+activity.marked_for_homework,
                {
                  state: {
                    ...filterState
                  },
                }
            )
          } else {
            toast.error("Sorry, Activity Key Missing", {
              autoClose: 3000, // 3 seconds in this example
            })
          }
        } else {
          toast.error("Sorry, Activity Key Missing", {
            autoClose: 3000, // 3 seconds in this example
          })
        }
      }

      const triggerRediectActivty = (activity) => {
         console.log(activity)
        if(Number(activity.activityType) === 0 || Number(activity.activityType) === 8){
          assessementActivitySummary(activity);
        }else{
          WorksheetActivity(activity);
        }
    }
return (
<React.Fragment>
<Loader
        show={loader}
        type="body"
      // stack="vertical"
      // message="Loading Data"
      />
  <ToastContainer autoClose={3000} />
  <div className="page-wrapper">
    <div className="cs-pg-header bg-dark-blue py-3 pb-5">
      <Container className="custom-wt">
        <div className="">
          <div className="mt-0">
            <Link className="text-white font-size-14" to={"/"}> {" "}
                  <span>
                    <i className=" fas fa-chevron-left me-1"></i>
            </span>{" "}
            BACK TO DASHBOARD
            </Link>
          </div>
          <div className="pg-title">Recent Evaluations</div>
        </div>
      </Container>
    </div>
    <Container className="custom-wt">

      <div className="page-inner_section mt-5 pt-2">
        <div className="pd-homework-section assessment-width-hold pb-100">
          <div className="page-header mb-4">

            {/* <div className="pg-info">
              <ul className="pg-tab list-unstyled mb-0 d-flex align-items-center">
                <li>SUBJECT</li>
                {subjectOptions.map((subject) => (// Map over each subject in subjectOptions 
                    <li
                      key={subject} // Set a unique key for each list item
                      className={selectedSubject === subject.subject_id ? "active" : ""} // Set class to "active" if selectedSubject matches the current subject 
                      onClick={() => handleSelectSubject(subject.subject_id)} // Set up click event handler to call handleSelectSubject with the current subject 
                    >
                      {selectedSubject === subject.subject_id && ( // Conditionally render a checkmark if selectedSubject matches the current subject 
                        <span>
                          <i className="fas fa-check"></i>
                        </span>
                      )} {" "} {subject.subject_name}
                    </li>
                  ))}
               
              </ul>
            </div> */}
          </div>
          <div className="hw-list mt-4">
            <ul className="list-unstyled mb-0">
              <li className="justify-content-between">
                {/* <p className="mb-0 text-uppercase luminous-wht">
                  <span className="text-warning fw-semibold font-size-12 me-1">{selectedSubjectName}</span>
                </p> */}
                <div className="d-flex align-items-start pb-4">
                  <div className="summary-child-left me-5">
                    <h3 className="bigger-ft mb-0">Recent Evaluations List</h3>
                    <div className="font-size-16 fw-bold text-dark d-flex align-items-center gap-2 mt-0">
                      <span className="fw-light">For</span>{username
                    ? username.st_first_name
                      ? username.st_first_name + " " + username.st_surname
                      : ""
                    : ""}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <form className="app-search page-search" style={{width: '35%'}}>
                      <div className="position-relative">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search for Session, Activity Name..."
                          value={searchText  || ""}
                          onChange={e => setSearchText(e.target.value)}
                        />
                        <span className="ion ion-ios-search"></span>
                      </div>
                    </form>
                </div>
                <div className="mst-ct1">
                  {/* <h4 className="mt-3 font-size-20 fw-bold text-dark mb-1">
                    🏆 Topics with High Mastery (More than 70)
                  </h4> */}
                  {/* <p className="font-size-18 mb-0">
                    You're a champion at these game! Keep up the good work.
                  </p> */}
                  <div className="table-responsive mt-4">
                    <Table className="table custom-table tb-custom-pd">
                      <thead>
                        <tr>
                          <th width="5%" className="text-center">
                            S.No
                          </th>
                          <th width="15%" className="text-center">Date</th>
                          <th width="15%" className="text-center">Session</th>
                          <th width="10%" className="text-center">
                           Activity
                          </th>
                          <th width="30%" className="text-center">
                           Activity Name
                          </th>
                          <th width="10%" className="text-center">
                           Coins
                          </th>
                           <th width="10%" className="text-center">
                           Score
                          </th>
                          <th width="5%" className="text-center">
                            VIEW
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {
                        filteredActivities?.length === 0 ? (
                          // Render a single row with "No data" if masryScoreData is empty
                          <tr>
                            <td colSpan="8" className="text-center font-size-18 fw-medium">No data yet</td>
                          </tr>
                        ) : (
                          // Render table rows if masryScoreData is not empty
                          filteredActivities.sort((a, b) => new Date(b.ses_date) - new Date(a.ses_date))
                          .map((item, index) => (
                            <tr key={index}>
                              <td className="text-center font-size-18 fw-medium">{index + 1}</td>
                              <td className="font-size-18 fw-bold text-dark">{moment(item.ses_date).format('DD MMM YYYY')}</td>
                              <td className="text-center font-size-18 text-dark">{item.sest_name}</td>
                              <td className="text-center font-size-18 text-dark">{item.activityMethod}</td>
                              <td className="text-center font-size-18 text-dark">{item.name}</td>
                              <td className="text-center font-size-18 fw-bold text-dark">{item.coins}</td>
                              <td className="text-center font-size-18 fw-bold text-dark">{item.score}</td>
                              <td className="text-center font-size-18 text-dark"><i className="mdi mdi-eye font-size-24" style={{ color: '#38a4f8' }} onClick={() => triggerRediectActivty(item)}></i></td>
                            </tr>
                          ))
                        )
                      }


                   
                      </tbody>
                    </Table>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Container>
  </div>
</React.Fragment>
)
}

ManualMarkList.propTypes = {
t: PropTypes.any,
}

export default withTranslation()(ManualMarkList)